import recentlyViewedSection from "../../components/recentlyViewedSection/index.vue";

export default {
  name: "recentlyViewed",
  components: {
    recentlyViewedSection,
  },
};
